import React, { useState } from "react";
import { iconDemo } from "utils/constants";
import { compose } from "redux";
import { useNavigate } from "react-router-dom";
import enhancer from "./enhancer/RegisterFormEnhancer";
import axios from "axios";
import AppModal from "components/ui/AppModal/AppModal";
// import loginBackVideo from "assets/images/VídeoBackGround.mp4";
import TermsModal from "./components/TermsModal/index";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import styles from "./auth.module.css";

const Register = props => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [instructions, setInstructions] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConf, setShowPasswordConf] = useState(false);
  const [feedbackModal, setFeedbackModal] = useState({
    open: false,
    variant: "custom",
    title: "",
    message: "",
    confirmText: "OK"
  });
  const [afterConfirmRoute, setAfterConfirmRoute] = useState(null);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const closeFeedbackModal = () =>
    setFeedbackModal(prev => ({ ...prev, open: false }));

  const handleConfirm = () => {
    closeFeedbackModal();
    if (afterConfirmRoute) {
      const route = afterConfirmRoute;
      setAfterConfirmRoute(null);
      navigate(route);
    }
  };

  const handleRegister = async e => {
    e.preventDefault();
    const errors = await props.validateForm();
    if (props.isValid) {
      submitForm(props.values);
    } else {
      Object.keys(errors || {}).forEach(field => {
        props.setFieldTouched(field, true);
      });
      if (errors?.exampleCheck1) {
        setAfterConfirmRoute(null);
        setFeedbackModal({
          open: true,
          variant: "warning",
          title: "Termos e Condições",
          message:
            "Você precisa concordar com os Termos e Condições para prosseguir com o cadastro."
        });
      }
    }
  };

  const submitForm = async values => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/signup`,
        values
      );
      if (response.status === 201) {
        setAfterConfirmRoute("/login");
        setFeedbackModal({
          open: true,
          variant: "success",
          title: "Registro Bem-sucedido!",
          message:
            "Por favor, verifique seu e-mail para acessar a plataforma."
        });
      } else {
        setAfterConfirmRoute(null);
        setFeedbackModal({
          open: true,
          variant: "error",
          title: "Erro!",
          message: "Erro desconhecido ao registrar usuário."
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 406) {
        setAfterConfirmRoute(null);
        setFeedbackModal({
          open: true,
          variant: "error",
          title: "Erro!",
          message: error.response.data.detail
        });
      } else {
        setAfterConfirmRoute(null);
        setFeedbackModal({
          open: true,
          variant: "error",
          title: "Erro!",
          message: "Erro desconhecido ao registrar usuário."
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const { values, handleChange, handleBlur, errors, touched, submitCount, setFieldValue } = props;

  const Error = ({ field, class: cls }) => {
    if ((errors[field] && touched[field]) || submitCount > 0) {
      return <span className={cls || styles.errorMsg}>{errors[field]}</span>;
    }
    return <span />;
  };

  const secureText = password => {
    const regexUppercase = /[A-Z]/;
    const regexLowercase = /[a-z]/;
    const regexNumber = /[0-9]/;
    const regexSpecial = /[^A-Za-z0-9]/;
    const validations = {
      case: regexUppercase.test(password) && regexLowercase.test(password),
      number: regexNumber.test(password),
      length: password.length >= 6,
      special: regexSpecial.test(password)
    };
    const strength = Object.values(validations).filter(Boolean).length;
    setPasswordStrength(strength);
    const missing = [];
    if (!validations.case) missing.push("Use letras maiúsculas e minúsculas.");
    if (!validations.number) missing.push("Adicione pelo menos um número.");
    if (!validations.special) missing.push("Use pelo menos um caractere especial.");
    if (!validations.length) missing.push("Sua senha deve ter no mínimo 6 caracteres.");
    setInstructions(missing);
  };

  const strengthColor = passwordStrength < 2 ? "#f87171" : passwordStrength < 4 ? "#fbbf24" : "#4ade80";
  const strengthPct = `${(passwordStrength / 4) * 100}%`;

  return (
    <div className={styles.root}>
{/* <video autoPlay muted loop className={styles.videoBg}>
        <source src={loginBackVideo} type="video/mp4" />
      </video> */}
      <div className={styles.overlay} />

      <div className={styles.card}>
        <div className={styles.logoWrap}>
          <img src={iconDemo} alt="Vertex4D" className={styles.logo} />
        </div>
        <h1 className={styles.title}>Criar Conta</h1>
        <p className={styles.subtitle}>Cadastre-se e comece a usar a plataforma.</p>

        <form onSubmit={handleRegister} noValidate>
          <div className={styles.formGroup}>
            <label className={styles.label}>Nome Completo</label>
            <input
              type="text"
              id="name"
              name="name"
              className={styles.input}
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Seu nome completo"
            />
            <Error field="name" />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Email</label>
            <input
              type="email"
              id="email"
              name="email"
              className={styles.input}
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="seu@email.com"
            />
            <Error field="email" />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Telefone</label>
            <PhoneInput
              id="phone"
              name="phone"
              className="auth-phone-input"
              placeholder="Informe seu telefone"
              value={values.phone}
              onChange={value => setFieldValue("phone", value || "")}
              onBlur={handleBlur}
              defaultCountry="BR"
              international
            />
            <Error field="phone" />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Área de Atuação</label>
            <select
              id="areas_of_expertise"
              name="areas_of_expertise"
              className={styles.select}
              value={values.areas_of_expertise}
              onChange={handleChange}
              onBlur={handleBlur}
            >
              <option value="" disabled>Selecione uma opção...</option>
              <option value="Engenharia / Construção">Engenharia / Construção</option>
              <option value="Projeto / Arquitetura">Projeto / Arquitetura</option>
              <option value="Infraestrutura / Transporte">Infraestrutura / Transporte</option>
              <option value="Energia / Utilities">Energia / Utilities</option>
              <option value="Meio Ambiente / Sustentabilidade">Meio Ambiente / Sustentabilidade</option>
              <option value="Topografia / Geomática">Topografia / Geomática</option>
              <option value="Mineração / Indústria">Mineração / Indústria</option>
              <option value="Agronegócio / Florestal">Agronegócio / Florestal</option>
              <option value="Imobiliário / Patrimônio">Imobiliário / Patrimônio</option>
              <option value="Seguros / Inspeções">Seguros / Inspeções</option>
              <option value="Operações com Drones">Operações com Drones</option>
              <option value="Filmagem / Fotografia">Filmagem / Fotografia</option>
              <option value="Segurança / Monitoramento">Segurança / Monitoramento</option>
              <option value="Bombeiros / Perícia">Bombeiros / Perícia</option>
              <option value="Outro">Outro</option>
            </select>
            <Error field="areas_of_expertise" />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Senha</label>
            <div className={styles.inputGroup}>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                className={styles.input}
                value={values.password}
                onChange={e => { handleChange(e); secureText(e.target.value); }}
                onBlur={handleBlur}
                placeholder="••••••••"
              />
              <div
                className={styles.inputGroupAppend}
                onClick={() => setShowPassword(!showPassword)}
              >
                <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
              </div>
            </div>
            <Error field="password" />
            {values.password && (
              <div className={styles.progressBar}>
                <div
                  className={styles.progressFill}
                  style={{ width: strengthPct, background: strengthColor }}
                />
              </div>
            )}
            {instructions.length > 0 && passwordStrength < 4 && (
              <ul className={styles.strengthList}>
                {instructions.map((inst, i) => <li key={i}>{inst}</li>)}
              </ul>
            )}
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Confirme a Senha</label>
            <div className={styles.inputGroup}>
              <input
                type={showPasswordConf ? "text" : "password"}
                id="passwordCheck"
                name="passwordCheck"
                className={styles.input}
                value={values.passwordCheck}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="••••••••"
              />
              <div
                className={styles.inputGroupAppend}
                onClick={() => setShowPasswordConf(!showPasswordConf)}
              >
                <i className={`fa ${showPasswordConf ? "fa-eye-slash" : "fa-eye"}`} />
              </div>
            </div>
            <Error field="passwordCheck" />
          </div>

          <div className={styles.checkRow}>
            <input
              type="checkbox"
              id="exampleCheck1"
              name="exampleCheck1"
              className={styles.checkbox}
              onChange={handleChange}
              onBlur={handleBlur}
              checked={values.exampleCheck1}
            />
            <label className={styles.checkLabel} htmlFor="exampleCheck1">
              Concordo com{" "}
              <button type="button" className={styles.checkLink} onClick={handleShowModal}>
                Termos &amp; Condições
              </button>
            </label>
          </div>
          <Error field="exampleCheck1" />

          <button
            type="submit"
            className={`${styles.btn} ${styles.btnPrimary}`}
            disabled={loading}
          >
            {loading ? <><div className={styles.spinner} /> Registrando...</> : "Registrar"}
          </button>
        </form>

        <p className={styles.linkRow}>
          Já possui uma conta?{" "}
          <button className={styles.link} onClick={() => navigate("/login")}>
            Acesse
          </button>
        </p>
      </div>

      <TermsModal show={showModal} onHide={handleCloseModal} />

      <AppModal
        isOpen={feedbackModal.open}
        onClose={closeFeedbackModal}
        allowOutsideClick={true}
        variant={feedbackModal.variant}
        title={feedbackModal.title}
        message={feedbackModal.message}
        confirmText={feedbackModal.confirmText}
        cancelText={null}
        onConfirm={handleConfirm}
        onCancel={closeFeedbackModal}
      />
    </div>
  );
};

export default compose(enhancer)(Register);
